<template>
  <section>
    <form @submit.prevent="submitForm" class="m-form m-form--state">
      <div class="modal-body">
        <div class="m-portlet__body">
          <div class="form-group m-form__group row">
            <div :class="[{'has-danger': errors.has('manu_name')}, 'col-lg-4']">
              <label for="name">{{'manu_name' | translate | capitalize }}</label>
              <input type="text" ref="manu_name" id="manu_name" v-model="manufacturer_name" name="manu_name" :placeholder="'enter_manu_name' | translate | capitalize" class="form-control m-input" v-validate="'required'">
              <span v-show="errors.has('manu_name')" class="m-form__help m--font-danger"> {{errors.first('manu_name')}} </span>
            </div>
            <div :class="[{'has-danger': errors.has('structure')}, 'col-lg-8']">
              <label for="name">{{'structure' | translate | capitalize }}</label>
              <input type="text" ref="structure" id="structure" v-model="send_structure" name="structure" :placeholder="'enter_structure' | translate | capitalize" class="form-control m-input" v-validate="'required'">
              <span v-show="errors.has('structure')" class="m-form__help m--font-danger"> {{errors.first('structure')}} </span>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button v-on:click="reset()" type="button" class="btn btn-secondary" :data-dismiss="'modal'" id="btn-cancel-approve-manufacturer">
          {{'close' | translate | capitalize }}
        </button>
        <button type="submit" class="btn btn-primary" @submit.prevent="submitForm">
          {{'save' | translate | capitalize }}
        </button>
      </div>
    </form>
  </section>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
  props: {
    data_send: Object
  },
  data () {
    return {
      manufacturer_id: '',
      manufacturer_name: '',
      send_structure: '',
      edit: false
    }
  },
  computed: {
    ...mapGetters({ modal: 'getStatusManufacturerModal', permissions: 'getUserPermissions' })
  },
  methods: {
    ...mapActions(['setStatusManufacturerModal', 'modifyManufacturer', 'addManufacturer']),
    ...mapMutations(['updateStatusManufacturerModal']),
    submitForm () {
      this.$validator.validateAll()
        .then((result) => {
          if (result) {
            if (this.edit) {
              this.modify()
            } else {
              this.create()
            }
          }
        })
    },
    focusInput () {
      this.$refs.manu_name.focus()
    },
    modify () {
      var manufacturer_data = {
        id: this.manufacturer_id,
        name: this.manufacturer_name,
        structure: this.send_structure
      }
      this.$spinner.show()
      this.modifyManufacturer(manufacturer_data)
        .then((res) => {
          this.$spinner.remove()
          if (res.status === 200) {
            this.$toast(res.data.message, 1)
            this.setStatusManufacturerModal(false)
            document.getElementById('btn-cancel-approve-manufacturer').click()
          }
        })
        .catch((err) => {
          this.$spinner.remove()
          document.getElementById('btn-cancel-approve-manufacturer').click()
          this.$toast(res.data.message, 4)
          console.log(err)
        })
    },
    create () {
      var manufacturer_data = {
        name: this.manufacturer_name,
        structure: this.send_structure
      }
      this.addManufacturer(manufacturer_data)
        .then((res) => {
          this.$spinner.remove()
          if (res.status === 200) {
            this.$toast(res.data.message, 1)
            this.setStatusManufacturerModal(false)
            document.getElementById('btn-cancel-approve-manufacturer').click()
          }
        })
        .catch((err) => {
          this.$spinner.remove()
          document.getElementById('btn-cancel-approve-manufacturer').click()
          this.$toast(res.data.message, 4)
          console.log(err)
        })
    },
    reset () {
      this.$validator.reset()
      this.setStatusManufacturerModal(false)
      this.edit = false
    }
  },
  created () {

  },
  watch: {
    modal (newVal, oldVal) {
      if (oldVal === false && newVal === true) {
        this.$nextTick(() => {
          if (this.data_send.id) {
            this.manufacturer_name = this.data_send.name
            this.send_structure = this.data_send.structure
            this.manufacturer_id = this.data_send.id
            this.edit = true
          } else {
            this.manufacturer_name = ''
            this.send_structure = ''
            this.manufacturer_id = ''
            this.edit = false
            this.$validator.reset()
          }
        })
      }
    }
  }
}
</script>

<style scope>
.center-custom{
  text-align: center !important;
  margin: 0 !important;
}

</style>


// WEBPACK FOOTER //
// NewManufacturer.vue